// 公示查询
import request from '@/untils/request/request.js'

// 首页
export function queryIndex(params) {
  return request({
    url: `/publicity/sys/queryIndex`,
    method: 'GET',
    data: params
  });
}

// 域名查询
export function getNameByPublicDomain(params) {
  // const typeNumber = 'project_information';
  return request({
    url: `/user/domain/info/getNameByPublicDomain`,
    method: 'GET',
    data: params
  });
}

// 首页-项目年份列表查询
export function queryPublicityProjectListIndex(params) {
  // const typeNumber = 'project_information';
  return request({
    url: `/publicity/sys/queryPublicityProjectListIndex`,
    method: 'GET',
    data: params
  });
}

// 首页-项目列表（分页）查询
export function queryPublicityProjectPage(params) {
  // const typeNumber = 'project_information';
  return request({
    url: `/publicity/sys/queryPublicityProjectPage`,
    method: 'GET',
    data: params
  });
}

// 首页-征收计划（分页）查询
export function queryAcquisitionPlanPage(params) {
  // const typeNumber = 'project_information';
  return request({
    url: `/project/planGuide/publicity/queryAcquisitionPlanPage`,
    method: 'GET',
    data: params
  });
}

// 首页-办事指南（分页）查询
export function queryGuidePage(params) {
  // const typeNumber = 'project_information';
  return request({
    url: `/project/planGuide/publicity/queryPlanGuidePage`,
    method: 'GET',
    data: params
  });
}

// 首页-政策法规
export function queryPolicyRegulationIndexPageList(params) {
  // const typeNumber = 'project_information';
  return request({
    url: `/project/policyRegulation/publicity/queryPolicyRegulationIndexPageList/1`,
    method: 'GET',
    data: params
  });
}

// 首页-政策法规详情
export function queryPolicyRegulationDetail(id) {
  // const typeNumber = 'project_information';
  return request({
    url: `/project/policyRegulation/publicity/queryPolicyRegulationDetail/${id}`,
    method: 'GET'
  });
}

// 首页-通知公告
export function queryPolicyTheme(params) {
  // const typeNumber = 'project_information';
  return request({
    url: `/project/policyRegulation/publicity/queryPolicyRegulationIndexPageList/2`,
    method: 'GET',
    data: params
  });
}

// 首页-办事指南-征收计划详情
export function queryPlanGuideInfo(id) {
  return request({
    url: `/project/planGuide/publicity/queryPlanGuideInfo/${id}`,
    method: 'get'
  });
}

// 附件预览
export function downloadFile(flag, id) {
  return request({
    url: `/publicity/sys/downloadFile/${flag}/${id} `,
    method: 'get'
  });
}

// 项目内-项目详情
export function queryPublicityProjectDetail(projectId) {
  // console.log(projectId)
  // const typeNumber = 'project_information';
  return request({
    url: `/publicity/project/${projectId}/queryPublicityProjectDetail`,
    method: 'GET'
  });
}

// 项目内-政策法规 公告公示
export function queryPolicyRegulationPageList(projectId, params) {
  return request({
    url: `/publicity/project/${projectId}/queryPublicityItemPage`,
    method: 'get',
    data: params
  });
}

// 项目内-政策法规 公告公示 详情
export function queryPublicityItemDetail(projectId, id) {
  return request({
    url: `/publicity/project/${projectId}/queryPublicityItemDetail/${id}`,
    method: 'get'
  });
}

// 项目内-补偿方案
export function queryCompensationScheme(projectId) {
  return request({
    url: `/publicity/project/${projectId}/queryCompensationScheme`,
    method: 'get'
  });
}

// 个人查询-分户信息
export function queryHouseholdIndex(projectId, params) {
  return request({
    url: `/publicity/household/${projectId}/queryHouseholdIndex`,
    method: 'GET',
    data: params
  });
}

// 个人查询-更多产权信息查询
export function getFileInformationList(projectId) {
  return request({
    url: `/publicity/household/${projectId}/queryAllHouseholdCode`,
    method: 'get'
  })
}

// 个人查询-公示目录
export function getPublicityCatalogList(projectId) {
  return request({
    url: `/publicity/household/${projectId}/queryPublicityList`,
    method: 'get',
  })
}

// 个人查询-公示目录-分户附件
export function getHouseholdAttachmentList(projectId, params) {
  return request({
    url: `/publicity/household/${projectId}/queryPublicityAttachmentPage`,
    method: 'get',
    data: params
  })
}

// 在线选房-小区房源(分页)
export function getEstateInfoVoPage(projectId, params) {
  return request({
    url: `/project/house/base/${projectId}/queryEstateInfoVoPage`,
    method: 'get',
    data: params
  });
}

// 在线选房-查询楼栋单元结构
export function getHousingBuildingUnitTree (projectId, estateId, params) {
  return request({
    url: `/project/house/base/${projectId}/queryHousingBuildingUnitTree/${estateId}`,
    method: 'get',
    data: params
  });
}

// 在线选房-查询楼栋单元结构
export function queryHousingHouseOfFloorByZh(projectId, params) {
  return request({
    url: `/project/house/base/${projectId}/queryHousingHouseOfFloorByZh`,
    method: 'get',
    data: params
  });
}

// 在线选房-查询楼栋单元结构
export function queryHousingHouseOfFloorWithTaoTypeByZh (projectId, householdId, params) {
  return request({
    url: `housing/base/queryHousingHouseOfFloorWithTaoTypeByZh/${projectId}/${householdId}`,
    method: 'get',
    data: params
  });
}

// 在线选房-查询楼栋单元结构
export function getHousingHouseOfFloor(projectId, params) {
  return request({
    url: `/project/house/base/${projectId}/queryHousingHouseOfFloor`,
    method: 'get',
    data: params
  });
}

// 在线选房-获取小区信息
export function getEstateInfoByEstateId(projectId, estateId) {
  return request({
    url: `/housing/publicity/${projectId}/getEstateInfoByEstateId/${estateId}`,
    method: 'get'
  });
}

// 在线选房-通过项目主键和小区ID户型信息图
export function getHousingHouseTypeAndAttachmentList(projectId, estateId) {
  return request({
    url: `/housing/publicity/${projectId}/queryHousingHouseTypeAndAttachmentList/${estateId}`,
    method: 'get'
  });
}
// 根据房号 ID 获取房号信息
export function getHousingHouseNumber(projectId, houseId) {
  return request({
    url: `/project/house/base/${projectId}/getHousingHouseNumber/${houseId}`,
    method: 'GET'
  });
}
// 在线选房-根据楼盘id查询相册
export function getEstateAttachmetsTypeList(params) {
  return request({
    url: `/housing/source/estatephoto/queryEstateAttachmetsTypeList`,
    method: 'get',
    data: params
  });
}
// 查询分户已选房源
export function queryHouseholdSelectHouseList(projectId, householdId) {
  return request({
    url: `/publicity/household/${projectId}/queryHouseholdSelectHouseList?householdId=${householdId}`,
    method: 'GET'
  });
}
// 个人查询登录接口
export function loginHouseholdIndex(params) {
  return request({
    url: `/publicity/login/loginHouseholdIndex`,
    method: 'POST',
    data: params
  });
}

// 退出个人查询
export function logoutHouseholdIndex(projectId) {
  return request({
    url: `/publicity/login/logoutHouseholdIndex`,
    method: 'POST'
  });
}

// 验证码登录
export function verifyCodeLogin(params) {
  return request({
    url: `/publicity/login/verifyCodeLogin`,
    method: 'POST',
    data: params
  });
}
// 保存分户预选房源
export function saveSelectedHouse(projectId, householdId, data) {
  return request({
    url: `/project/household/house/preselection/${projectId}/saveHouse/${householdId}`,
    method: 'GET',
    data
  });
}

// 保存分户预选房源
export function queryHouseholdHouseTaoTypeAndSelectHouseNumList (data) {
  return request({
    url: `/housing/taotype/queryHouseholdHouseTaoTypeAndSelectHouseNumList`,
    method: 'GET',
    data
  });
}

// 校验剩余面积
export function queryVerifyHousingHouseData (projectId, data) {
  return request({
    url: `/housing/base/queryVerifyHousingHouseData/${projectId}`,
    method: 'GET',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/publicinquiry.api.js